import React, { Component } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { tokenRequestAction } from "../../../modules/forgotPassword/action";
import ForgotPasswordForm from "./ForgotPasswordForm";


class ForgotPassword extends Component {
  state = {
    successMessage: false
  };

  componentWillReceiveProps(nextProps) {
    if (nextProps.tokenSent) {
      this.setState({ successMessage: true });
    }
  }

  handleSubmit = userEmail => {
    this.props.tokenRequestAction(userEmail);
  };

  render() {
    const { successMessage } = this.state;
    const { tokenSent } = this.props;
    if (successMessage) {
      return (
        <div className="">
          <div className="mainform">
            <p className="forgotPasswordMessage">{tokenSent.message}</p>
          </div>
        </div>
      );
    }
    return <ForgotPasswordForm handleSubmit={this.handleSubmit} />;
  }
}

const mapStateToProps = state => {
  return {
    tokenSent: state.resetPasswordReducer.tokenSent
  };
};

const mapDispatchToProps = dispatch =>
  bindActionCreators({ tokenRequestAction }, dispatch);

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ForgotPassword);



// WEBPACK FOOTER //
// ./src/components/public/ForgotPassword/ForgotPassword.js